<li *ngIf="!isLogged" style="margin-left: 10px;" class="nav-item" data-bs-toggle="collapse"
  data-bs-target=".navbar-collapse.show"><a routerLink="/log-in" class="nav-link">Iniciar Sesión</a></li>

<li style="margin-left: 10px; margin-top: 25px;" *ngIf="isLogged" class="nav-item">

  <img href="javascript:void(0)" [src]="user.photo || 'assets/default-user.png'" class="rounded-circle" width="40"
    height="40" />
  <label style="    color: #ffffff;
  text-transform: capitalize;
  transition: all 0.5s;
  padding: 0;
  font-weight: 600;
  text-decoration: dotted;
  font-size: 13px;
  margin-left: 10px;
  margin-right: 0;
  padding-bottom: 30px;">{{user.name | truncate:15}}<i class='bx bx-chevron-down'></i></label>
  <ul class="dropdown-menu">
    <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/panel/"
        class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Panel</a></li>

    <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a
        routerLink="/panel/profile/" class="nav-link" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">Perfil</a></li>

    <li class="nav-item pointer" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a (click)="logout()"
        class="nav-link">Cerrar sesión</a></li>
  </ul>
</li>